import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
export function HeroSection() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[80vh] sm:min-h-screen flex items-center justify-center pt-20 pb-10 sm:pt-24 sm:pb-16 px-4 overflow-hidden" data-id="element-88">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-accent/5 rounded-full blur-[120px] pointer-events-none" data-id="element-89"></div>

      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-6 sm:gap-12 items-center relative z-10" data-id="element-90">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col gap-5 sm:gap-8" data-id="element-91">
          <div className="space-y-4" data-id="element-92">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-surface border border-white/10 text-xs font-medium tracking-widest text-accent uppercase" data-id="element-93">
              <span className="w-2 h-2 rounded-full bg-accent animate-pulse" data-id="element-94"></span>
              Nuevo Método
            </motion.div>

            <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.1] text-text" data-id="element-95">
              Transforma Simples Cartulinas en Esculturas de{' '}
              <span className="text-accent italic" data-id="element-96">Galería de Arte</span> en
              Menos de 60 Minutos...
            </h1>
          </div>

          <p className="text-lg sm:text-xl text-textMuted leading-relaxed max-w-xl" data-id="element-97">
            El Método "Sculpt-It" es el primer sistema paso a paso que te
            permite decorar tu hogar con piezas de lujo de $200 USD por el costo
            de un café de papelería. ¡Incluso si sientes que no tienes ni un
            gramo de creatividad!
          </p>

          <div className="flex flex-col gap-4" data-id="element-98">
            <button onClick={scrollToPricing} className="group relative inline-flex items-center justify-center gap-3 bg-accent text-background px-8 py-5 rounded-lg font-bold text-lg transition-all hover:bg-accentHover hover:scale-[1.02] active:scale-[0.98] shadow-[0_0_40px_rgba(212,168,83,0.3)]" data-id="element-99">
              <span data-id="element-100">Quiero Mi Bundle por $9.99</span>
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-101" />
            </button>
            <p className="text-sm text-textMuted/80 text-center sm:text-left flex items-center justify-center sm:justify-start gap-2" data-id="element-102">
              <span className="text-accent" data-id="element-103">✓</span> Sin Máquinas Costosas
              <span className="text-accent ml-2" data-id="element-104">✓</span> Sin Ser "Artista"
              <span className="text-accent ml-2" data-id="element-105">✓</span> Sin Frustraciones
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 1,
        delay: 0.3,
        ease: 'easeOut'
      }} className="relative" data-id="element-106">
          <div className="relative rounded-2xl overflow-hidden border border-white/10 shadow-2xl shadow-black/50 group" data-id="element-107">
            <div className="absolute inset-0 bg-gradient-to-t from-background/80 via-transparent to-transparent z-10" data-id="element-108"></div>
            <motion.img src="https://cdn.magicpatterns.com/uploads/dMh4ycaKKDb9qEaVNzJUYf/mk-1.png" alt="Sculpt-It Bundle Display" loading="eager" decoding="async" className="w-full h-auto object-cover transform transition-transform duration-700 group-hover:scale-105" data-id="element-109" />
          </div>

          {/* Decorative elements */}
          <div className="absolute -top-6 -right-6 w-24 h-24 border-t border-r border-accent/30 rounded-tr-3xl" data-id="element-110"></div>
          <div className="absolute -bottom-6 -left-6 w-24 h-24 border-b border-l border-accent/30 rounded-bl-3xl" data-id="element-111"></div>
        </motion.div>
      </div>
    </section>;
}